module.exports = __webpack_public_path__ + "static/media/pic7.ccd26e67.jpg";